/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { SearchInput } from '@smartsheet/lodestar-core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SearchBarProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const searchInputStyle = css`
  flex-shrink: 0;
`;

export const SearchBar = ({
  value = '',
  onChange,
  placeholder = 'Search',
}: SearchBarProps) => {
  const [inputValue, setInputValue] = useState(value);
  const { t: translate } = useTranslation();

  const changeHandler = (value: string) => {
    setInputValue(value);
    onChange(value);
  };

  return (
    <SearchInput
      css={searchInputStyle}
      value={inputValue}
      onChange={changeHandler}
      placeholder={placeholder}
      aria-label={translate('common:search')}
    />
  );
};
